export const fieldsTranslationsEn = {
  'fields-parameters.navbar.services.title': 'Services',
  'fields-parameters.title': 'Field Parameters',
  'fields-parameters.services.table.title': 'Fields',
  'service.field_parameters.column.farmer_name.label': 'Farm',
  'service.field_parameters.column.field_number.label': 'Number of fields',
  'service.field_parameters.column.total_area.label': 'Total area (ha)',
  'service.field_parameters.detail_panel.column.field_name.label': 'Field name',
  'service.field_parameters.detail_panel.column.area.label': 'Area (ha)',
  'service.field_parameters.detail_panel.column.service.label': 'Service',
  'service.field_parameters.detail_panel.column.crop.label': 'Crop',
  'service.field_parameters.detail_panel.column.subscription.label': 'Subscription',
  'service.field_parameters.detail_panel.column.subscription.active.label': 'Active',
  'service.field_parameters.detail_panel.column.subscription.no_subscription.label': 'No subscription',
  'service.field_parameters.detail_panel.column.service.button.parameter.label': 'Parameters',
  'irrigation_field_service_parameters.button.undo.label': 'Undo changes',
  'irrigation_field_service_parameters.button.save.label': 'Save changes',
  'irrigation_field_service_parameters.multiple_edition.button.apply.label': 'Apply',
  'irrigation_field_service_parameters.multiple_edition.button.clear.label': 'Clear',
  'irrigation_field_service_parameters.multiple_edition.title.label': 'Multiple field editing',
  'irrigation_field_service_parameters.multiple_edition.info.setp1':
    '1- Fill in the fields you want to apply to multiple parcels',
  'irrigation_field_service_parameters.multiple_edition.info.setp2':
    '2- Select the fields for which you want to apply the parameters',
  'irrigation_field_service_parameters.multiple_edition.info.setp3':
    '3- Confirm by clicking the apply button (Warning: errors may appear)',
  'irrigation_field_service_parameters.multiple_edition.info.setp4': '4- Save to apply your update',
  'irrigation_field_service_parameters.table.Column.farmer_name.label': 'Farm',
  'irrigation_field_service_parameters.table.Column.field_number.label': 'Number of fields',
  'irrigation_field_service_parameters.table.Column.total_area.label': 'Total area (ha)',
  'irrigation_field_service_parameters.table.detail_panel.column.field.label': 'Field',
  'irrigation_field_service_parameters.table.detail_panel.column.soil.label': 'Soil',
  'irrigation_field_service_parameters.table.detail_panel.column.weather_station.label': 'Weather station',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_management.label': 'Irrigation management',
  'irrigation_field_service_parameters.table.detail_panel.column.irrigation_threshold.label': 'Irrigation threshold',
  'irrigation_field_service_parameters.table.detail_panel.column.assolment.label': 'Crop rotation',
  'fields-parameters.dialog.error.title': 'Error saving changes',
  'fields-parameters.dialog.error.legend': 'Some of your changes have encountered errors and were not saved.',
  'fields-parameters.dialog.error.contact':
    'If the problem persists, please submit these errors to our support service at csm@pixagri.fr',
};
